import React, { useContext, useEffect, useState } from "react";
import { CardGridWrapper } from "../../components/Card/CardGridWrapper";
import { AppContext } from "../../context";
import { Container } from "../Styles/Wrappers";
import CreativeCard from "./CreativeCard";
import { searchCreatives } from "./searchCreatives";
import "./Creative.css";
function Creative(props) {
  const [creatives, setCreatives] = useState([]);
  const info = useContext(AppContext);

  useEffect(() => {
    (async () => {
      const creatives = await searchCreatives();

      setCreatives(creatives);
    })();
  }, []);

  return (
    <div>
      <div class="ahp-creative-banner">
        <img
          src="https://aldeiashistoricasdeportugal.com/wp-content/uploads/2018/12/3-e1623065048923.png"
          alt="background"
        />
        <div className="ahp-creative-banner-content">
          <div className="ahp-creative-title">
            {info.t("creativeIndustries")}
          </div>
          <div className="ahp-creative-subtitle">
            Aldeias Históricas de Portugal
          </div>
          <div className="ahp-creative-description">
            Conheça os artistas das Indústrias Criativas das Aldeias Históricas
            de Portugal
          </div>
        </div>
      </div>
      <Container>
        <CardGridWrapper>
          {creatives?.length > 0 &&
            creatives?.map((product, index) => (
              <CreativeCard
                entity="creative"
                // storeProp={store}
                product={product}
                key={index}
              />
            ))}
          {creatives?.length === 0 && <div>SEM RESULTADOS</div>}
        </CardGridWrapper>
      </Container>
    </div>
  );
}

export default Creative;
